var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileiconn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.09873e-10C11.8132 -6.15562e-06 13.1136 0.258646 14.3268 0.76119C15.5401 1.26373 16.6425 2.00033 17.5711 2.92891C18.4997 3.8575 19.2363 4.95989 19.7388 6.17315C20.2414 7.3864 20.5 8.68676 20.5 9.99998C20.5 15.5228 16.0228 20 10.5 20C4.97717 20 0.5 15.5228 0.5 9.99998C0.5 4.47717 4.97717 1.09873e-10 10.5 1.09873e-10ZM11.5 11H9.5C7.0243 11 4.89884 12.4994 3.98211 14.6398C5.43261 16.6737 7.81142 18 10.5 18C13.1885 18 15.5674 16.6737 17.0179 14.6396C16.1012 12.4994 13.9757 11 11.5 11ZM10.5 3C8.84314 3 7.49998 4.34316 7.49998 6C7.49998 7.65684 8.84314 9 10.5 9C12.1568 9 13.5 7.65684 13.5 6C13.5 4.34316 12.1569 3 10.5 3Z",
    fill: "#5F6D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileiconn);
export default __webpack_public_path__ + "static/media/profileiconn.b0b0eb7ac0e4ec94c5d698881c430300.svg";
export { ForwardRef as ReactComponent };